<template>
  <f7-page>
    <f7-navbar color="pink" title="Go to Lists Task" back-link="Back"></f7-navbar>

    <f7-card>
      <f7-card-header>{{ task.name }}</f7-card-header>
      <f7-card-content>
        <img style="width: 100%;border-radius:8px" :src="task.img.src" />
        <p>{{ task.description }}</p>
      </f7-card-content>
    </f7-card>

    <f7-list color="pink">

      <f7-list-item title="Category" color="pink" smart-select>
        <select name="category">
            <optgroup label="List Category">
                <option :value="task.category" selected v-html="task.category"></option>
                <option value="pineapple">Pineapple</option>
                <option value="pear">Pear</option>
                <option value="orange">Orange</option>
                <option value="melon">Melon</option>
                <option value="peach">Peach</option>
                <option value="banana">Banana</option>
            </optgroup>
        </select>
      </f7-list-item>

    </f7-list>

  </f7-page>
</template>

<script>
    import Service from '../service';

    export default {
        data() {
            return {
                task: Service.getDish(this.$f7route.params.id),
            };
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/dish.vue